import * as universes from '@front/common/src/ducks/common/universes';
import * as basket from '@front/common/src/ducks/customer/basket';
import * as proAccounts from '@front/common/src/ducks/customer/pro-accounts';

export default {
  universes,
  proAccounts,
  basket,
};
